import { useCallback, useMemo, useState } from "react";
import { LineChartComponent } from "../../../../ChartComponents/LineChartFluent";
import { CustomCardWithMetricsFilter } from "../../../../SharedComponents/CustomCardWithMetricsFilter/CustomCardWithMetricsFilter";
import { ChartOption } from "../../../../SharedComponents/Interfaces/CustomCardWithMetrics.interfaces";
import {
  getOverallRevenueTrendChartData
} from "../ConsumptionRevenue/ConsumptionRevenueTab.helper";
import { ConsumptionRevenueTabChartsProps } from "../ConsumptionRevenue/ConsumptionRevenueTab.interfaces";
import { CONSUMPTION_REVENUE_TAB_STYLES as STYLES } from "../ConsumptionRevenue/ConsumptionRevenueTab.styles";

export const ConsumptionRevenueTabCharts = ({
  loading,
  onDataPointClick,
  onSelectedChartFilter,
  options
}: ConsumptionRevenueTabChartsProps) => {
  const [metricFilters, setMetricFilters] = useState<{ [key: string]: any }>({});
  const [width, setWidth] = useState<number | undefined>();
  const disableCustomCards = loading === false && !options?.originalData?.length;

  // Handlers
  const handleDataPointClick = useCallback(
    (option: ChartOption) => {
      const { title, value } = option;
      onDataPointClick?.(option);
      setMetricFilters((prev) => ({ ...prev, [title]: value }));
    },
    [onDataPointClick]
  );

  const handleResetFilters = useCallback(() => {
    onSelectedChartFilter({
      filterKey: "",
      value: ""
    });
  }, [onSelectedChartFilter]);

  // Memoized chart items
  const itemMemo = useMemo(() => {
    if (disableCustomCards) return [];
    return [
      {
        component: () => (
          <LineChartComponent
            data={getOverallRevenueTrendChartData(options?.filteredData ?? [], handleDataPointClick)}
            allowResize={true}
            height={250}
            isLoading={loading}
          />
        ),
        key: "customer-revenue-trend-chart",
        title: "Overall Revenue Trend"
      }
    ];
  }, [options, loading, width, handleDataPointClick, disableCustomCards]);

  return (
    <div className={STYLES.CLASS_NAMES.customCardContainer}>
      <CustomCardWithMetricsFilter
        itemMemo={itemMemo}
        loading={loading}
        metricFilters={metricFilters}
        onCardWidthChange={setWidth}
        onResetFilters={handleResetFilters}
        options={options}
        setMetricFilters={setMetricFilters}
      />
    </div>
  );
};
